var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from '@/events/AppEvents';
import { Box, Center, Text, Flex, Checkbox } from '@chakra-ui/react';
import { action, makeObservable, observable } from 'mobx';
import { Observer, observer } from 'mobx-react';
import React from 'react';
import { ScaleLoader } from 'react-spinners';
import { Virtuoso } from 'react-virtuoso';
import { BaseDialog, BaseDialogState } from './BaseDialog';
export class ChooseTagDialogState {
    constructor() {
        this.basedialogState = new BaseDialogState();
        this.tags = [];
        this.selectedtags = new Set();
        this.creating = false;
        this.error = "";
        makeObservable(this);
        this.basedialogState.setDisableOkButton(true);
        this.basedialogState.setOkLabel("Apply");
        this.basedialogState.setHeaderLabel("Select Tag");
        this.basedialogState.onOk = () => this.apply();
        APPEvent.addSubscriberForTaggingLetr((res) => {
            var _a;
            if (this.creating) {
                this.setCreating(false);
                if (res) {
                    (_a = this.updatecb) === null || _a === void 0 ? void 0 : _a.call(this, Array.from(this.selectedtags));
                    this.setOpen(false);
                }
                else {
                }
            }
        });
    }
    apply() {
        var _a;
        this.setCreating(true);
        (_a = this.applyCb) === null || _a === void 0 ? void 0 : _a.call(this, Array.from(this.selectedtags));
    }
    setError(error) {
        this.error = error;
    }
    setSelectedTag(tid, sel) {
        if (sel) {
            this.selectedtags.add(tid);
            this.basedialogState.setDisableOkButton(false);
        }
        else {
            this.selectedtags.delete(tid);
            if (this.selectedtags.size === 0) {
                this.basedialogState.setDisableOkButton(true);
            }
        }
    }
    setCreating(creating) {
        this.creating = creating;
    }
    setOpen(open) {
        this.basedialogState.setOpen(open);
        if (!open) {
            this.selectedtags.clear();
            this.setError("");
            this.basedialogState.setDisableOkButton(true);
        }
    }
}
__decorate([
    observable,
    __metadata("design:type", Set)
], ChooseTagDialogState.prototype, "selectedtags", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ChooseTagDialogState.prototype, "creating", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ChooseTagDialogState.prototype, "error", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ChooseTagDialogState.prototype, "setError", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Boolean]),
    __metadata("design:returntype", void 0)
], ChooseTagDialogState.prototype, "setSelectedTag", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ChooseTagDialogState.prototype, "setCreating", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ChooseTagDialogState.prototype, "setOpen", null);
let ChooseTagDialog = class ChooseTagDialog extends React.Component {
    constructor(prop) {
        super(prop);
    }
    drawTag(con) {
        var _a;
        return React.createElement(Flex, { key: con.id, mt: '10px', align: 'center' },
            React.createElement(Checkbox, { defaultChecked: this.props.state.selectedtags.has(con.id), onChange: (e) => this.props.state.setSelectedTag(con.id, e.currentTarget.checked) }),
            React.createElement(Box, { ml: '20px', className: 'dot', backgroundColor: (_a = con.color) !== null && _a !== void 0 ? _a : 'black' }),
            React.createElement(Text, { fontWeight: 'bold', fontSize: '20px', ml: '15px' }, con.name));
    }
    buildBody() {
        return React.createElement(Box, null,
            React.createElement(Flex, { justify: 'center', align: 'center', w: '100%' },
                React.createElement(Text, { mb: '10px', color: 'red' }, this.props.state.error)),
            React.createElement(Observer, null, () => React.createElement(Virtuoso, { style: { height: "400px", }, data: this.props.state.tags, itemContent: (index, ec) => this.drawTag(ec) })),
            this.props.state.creating && React.createElement(Box, { w: '100%', mt: '40px' },
                React.createElement(Center, null,
                    React.createElement(ScaleLoader, { color: 'green' }))));
    }
    render() {
        return React.createElement(BaseDialog, { state: this.props.state.basedialogState, body: this.buildBody() });
    }
};
ChooseTagDialog = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], ChooseTagDialog);
export { ChooseTagDialog };
